// 応募収集 URL（X 投稿 URL）の UI 側バリデーション。
// 形式: https://x.com/{screen_name}/status/{post_id}
// - screen_name は開催アカウント名と一致すること
// - post_id は数字のみであること
// - post_id より後ろに何も続かないこと（クエリパラメータ・フラグメント・追加パスは許容しない）
//   クエリパラメータ・フラグメントは UrlInput が入力時点で切り落とすため、ここには届かない。
// アカウント一致の最終確定はサーバ（NOT_MATCH）だが、即時フィードバックのため UI でも判定する。

// x.com / twitter.com のいずれかのドメインで、/{screen_name}/status/{数字} を抽出する。
const TWEET_POST_URL_PATTERN = /^https?:\/\/(?:x|twitter)\.com\/([A-Za-z0-9_]+)\/status\/(\d+)$/

export type TweetPostUrlValidationResult =
  | { valid: true }
  | { valid: false; reason: 'empty' }
  | { valid: false; reason: 'format' }
  | { valid: false; reason: 'accountMismatch'; actualScreenName: string }

type ParsedTweetPostUrl = {
  screenName: string
  postId: string
}

// URL から screen_name / post_id を抽出する。形式不正なら null。
const parseTweetPostUrl = (url: string): ParsedTweetPostUrl | null => {
  const matched = url.trim().match(TWEET_POST_URL_PATTERN)
  if (!matched) {
    return null
  }
  return { screenName: matched[1], postId: matched[2] }
}

// 入力 URL を開催アカウント名と照合して検証する。
export const validateTweetPostUrl = (url: string, campaignScreenName: string): TweetPostUrlValidationResult => {
  if (!url.trim()) {
    return { valid: false, reason: 'empty' }
  }

  const parsed = parseTweetPostUrl(url)
  if (!parsed) {
    return { valid: false, reason: 'format' }
  }

  if (parsed.screenName !== campaignScreenName) {
    return { valid: false, reason: 'accountMismatch', actualScreenName: parsed.screenName }
  }

  return { valid: true }
}

// URL 群のうち、post_id ベースで重複しているもの（2 件目以降）を返す。
export const findDuplicateUrls = (urls: string[]): string[] => {
  const seenPostIds = new Set<string>()
  const duplicates: string[] = []

  urls.forEach(url => {
    const parsed = parseTweetPostUrl(url)
    // 形式不正 URL は重複判定の対象外（形式エラーは validateTweetPostUrl 側で検出）。
    const key = parsed ? parsed.postId : url.trim()
    if (seenPostIds.has(key)) {
      duplicates.push(url)
      return
    }
    seenPostIds.add(key)
  })

  return duplicates
}
